var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// ./~/node-polyglot/~/object.assign/~/function-bind/index.js
// module id = 82
// module chunks = 0